import { render, staticRenderFns } from "./birth-company-list.vue?vue&type=template&id=51ac0e1a&scoped=true&"
import script from "./birth-company-list.vue?vue&type=script&lang=js&"
export * from "./birth-company-list.vue?vue&type=script&lang=js&"
import style0 from "./birth-company-list.vue?vue&type=style&index=0&id=51ac0e1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac0e1a",
  null
  
)

export default component.exports